<template>

    <div>
        <div v-for="messageRecord in recordsToRender" class="border-top">
            <div class="pt-3 pb-3" :class="paddingCss">
                <div class="row">
                    <div @click.prevent="$emit('go-to-message-detail', messageRecord)" class="col h6 mb-0">
                        <a href="#">
                            {{messageRecord.subject}}<span v-if="messageRecord.attachmentId"><i class="ml-2 fas fa-fw fa-paperclip"></i></span>
                        </a>

                        <span v-if="!messageRecord.readDate" class="text-portal-primary-blue">&#8226;</span>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col h6 mb-0">
                        <span class="fs-14">
                            {{messageRecord.fromName}}
                        </span>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col h6 mb-0">
                        <span class="fs-14">{{messageRecord.createdDate | formatToShortDate}} at {{messageRecord.createdDate | formatTime}} </span>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>


    export default {
        props: {
            recordsToRender: { type: Array },
            paddingCss: { type: String }
        }
    };
</script>

